import './GuideStartBanner.css';

import { useEffect } from 'react';
import { IonIcon } from '@ionic/react';
import { closeOutline, compassOutline } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';
import Button from '../../Button/Button';
import { useTranslate } from '../../../hooks/context/useTranslate';
import useRoutes from '../../../hooks/useRoutes';
import { useGuideContext } from '../../../context/GuideContext/GuideContext';
import { getGuideProgress } from '../../../utils/guides/guideProgressStore';

// First-login nudge: offered once per user until they open or dismiss it. Never blocks.
const GuideStartBanner = () => {
  const { t } = useTranslate();
  const history = useHistory();
  const routes = useRoutes();
  const { index, ensureIndex, progress, markProgress, activeTour, panelGuideId } =
    useGuideContext();

  useEffect(() => {
    ensureIndex();
  }, [ensureIndex]);

  const path = index?.paths[0];
  if (!path || activeTour || panelGuideId) return null;
  if (getGuideProgress(progress, 'path', path.id)) return null;

  return (
    <div className="guide-start-banner" role="status" data-guide-start-banner>
      <IonIcon icon={compassOutline} className="guide-start-banner-icon" />
      <div className="guide-start-banner-text">
        <div className="guide-start-banner-title">{path.title}</div>
        <div className="guide-start-banner-body">{path.summary ?? t('guide.banner.text')}</div>
      </div>
      <div className="guide-start-banner-actions">
        <Button
          small
          fill="solid"
          round={false}
          onClick={() => {
            markProgress('path', path.id, 'seen');
            history.push(routes.guides());
          }}
        >
          {t('guide.banner.open')}
        </Button>
        <Button
          small
          fill="clear"
          round={false}
          onClick={() => markProgress('path', path.id, 'dismissed')}
        >
          {t('guide.banner.later')}
        </Button>
      </div>
      <button
        type="button"
        className="guide-start-banner-close"
        aria-label={t('guide.close')}
        onClick={() => markProgress('path', path.id, 'dismissed')}
      >
        <IonIcon icon={closeOutline} />
      </button>
    </div>
  );
};

export default GuideStartBanner;
